// Main middleware
export const mainMiddleware = (store) => (next) => (action) => {
    // Add any main middleware logic here
    return next(action);
};

// Auth middleware
export const authMiddleware = (store) => (next) => (action) => {
    // Add any auth-specific middleware logic here
    return next(action);
};

